import { gql } from "@apollo/client";
import { AddressInfoClientFragment } from "domains/Task/graphql/fragments";
import { AddressInfoFragment } from "graphql/Address/fragments";

export const contactFragment = gql`
  fragment contactFragment on ContactInput {
    firstname
    lastname
    phoneNumber
    secondPhoneNumber
    email
    address {
      address
      place_id
      region
    }
  }
`;

export const clientFragment = gql`
  fragment clientFragment on Client {
    _id
    client_company_name
    client_UID
    client_phone_number
    client_address {
      address
      place_id
      region
      city
    }
    countries {
      name
    }
    client_default_address {
      firstname
      lastname
      phone_number
      address {
        address
        place_id
        region
        city
      }
    }
  }
`;

export const actionFragment = gql`
  fragment actionFragment on Action {
    _id
    reference
    updatedAt
    type
    executionDate
    executionTime
    status
    address {
      address
      country
    }
    startTime
    endTime
    items {
      code
      status
      description
      quantity
    }
  }

`;

export const CourseFragment = gql`
  fragment CourseFragment on Course {
    _id
    uid
    isIndividual
    createdAt
    startDate
    endDate
    status
    executionDate
    vehicleType
    driver {
      driver_UID
      driver_firstname
      driver_lastname
    }
    client {
      ...clientFragment
    }
    individualClient {
      contact {
        ...contactFragment
      }
    }
    actions {
      ...actionFragment
    }
  }
  ${clientFragment}
  ${actionFragment}
  ${contactFragment}
`;

export const ClientCreatedFragment = gql`
  fragment ClientCreatedFragment on DataOneClientCreationResponse {
    clientCreated {
      _id
      client_UID
      client_company_name
      client_activity
      client_phone_number
      client_email
      client_website
      client_address {
        ...AdressFragment
      }
      client_trade_register_url
      client_ninea_url
      client_ninea_number
      client_contact_firstname
      client_contact_lastname
      client_contact_job
      client_contact_phone_number
      client_contact_email
      client_contract_is_signed
      client_contract_start_date
      client_contract_end_date
      client_billing
      client_payment_mode
      client_payment_frequency
      client_picture_url
      isActive
      client_options_contracts {
        _id
        options_contract_libelle
        options_contract_clients {
          _id
        }
      }
      client_company_users {
        _id
        company_user_firstname
        company_user_job
        company_user_email
        company_user_profil
        company_user_clientId
        company_user_lastname
        company_user_phone_number
      }
      client_billing_accounts {
        _id
      }
      client_created_at
      client_updated_at
    }
  }
`;

export const AdressFragment = gql`
  fragment AdressFragment on Address {
    country
    city
    region
    address
    additional_address
    location {
      latitude
      longitude
    }
    place_id
  }
`;
